// ── Auth event bus ──────────────────────────────────────────────────────────
// Dispatch 'auth:logout' on the window to signal that the session has ended.
// The LoginGate component listens for this event and transitions back to the
// login form.

export const signalLogout = () => window.dispatchEvent(new Event('auth:logout'));
